module.exports = __webpack_public_path__ + "files/847832d2bfa2749ba158d3be4a7302e3.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-1.png
// module id = 490
// module chunks = 76